<div class="performance-title">
    {{ metricName() }}
    <app-info-tooltip style="float: right"
                      [title]="tooltipText()"></app-info-tooltip>
</div>
<div class="performance-metric">
    <div class="performance-value">
        @if (isLoading()) {
        <app-ellipsis-loader></app-ellipsis-loader>
        }
        @if (!isLoading()) {
        <div class="performance-kpi-value">
            @if (showPrecision()) {
            {{ currentKpi() | number: "1.2-2" }}
            } @else {
            {{ currentKpi() | number: "1.0-0" }}
            }
            @if (comparisonKpi !== undefined) {
            <svg xmlns="http://www.w3.org/2000/svg"
                 width="24"
                 height="24"
                 viewBox="0 0 24 24"
                 fill="none">
                <path d="M9.01 14H3C2.45 14 2 14.45 2 15C2 15.55 2.45 16 3 16H9.01V17.79C9.01 18.24 9.55 18.46 9.86 18.14L12.64 15.35C12.83 15.15 12.83 14.84 12.64 14.64L9.86 11.85C9.55 11.53 9.01 11.76 9.01 12.2V14ZM14.99 11.79V10H21C21.55 10 22 9.55003 22 9.00003C22 8.45003 21.55 8.00003 21 8.00003H14.99V6.21003C14.99 5.76003 14.45 5.54003 14.14 5.86003L11.36 8.65003C11.17 8.85003 11.17 9.16003 11.36 9.36003L14.14 12.15C14.45 12.46 14.99 12.24 14.99 11.79Z"
                      fill="#8D9093" />
            </svg>
            @if (showPrecision()) {
            {{ comparisonKpi | number: "1.2-2" }}
            } @else {
            {{ comparisonKpi | number: "1.0-0" }}
            }
            }
            <span class="performance-uom">{{ unitOfMeasure() }}</span>
        </div>
        }
    </div>
</div>
@if (comparisonKpi !== undefined) {
    @if (!isLoading()) {
<app-generic-trend [genericTrendText]="genericTrendText()"
                   [inverted]="inverted()"
                   [numericDayValue]="timePeriod()"
                   [valueOne]="comparisonKpi"
                   [valueTwo]="currentKpi()"
                   [showPrecision]="showPrecision()"
                   class="performance-compare"></app-generic-trend>
    }
} @else {
    @if (!isLoading()) {
<app-generic-trend [genericTrendText]="genericTrendText()"
                   [inverted]="inverted()"
                   [numericDayValue]="timePeriod()"
                   [percentChange]="percentChangedValue"
                   [showPrecision]="showPrecision()"
                   class="performance-compare"></app-generic-trend>
    }
}
